import get from 'lodash/get';
import { useEffect, useMemo, useState } from 'react';

import { useGlobalStore, useHasAuth } from 'lib/DataStore';
import { NewPlpService } from 'lib/apis/services/NewPlpListiing';
import { PlpTypes } from 'lib/apis/services/PlpListing';
import { ContentType } from 'lib/apis/services/PlpListing/type';
import { PlpActionService } from 'lib/apis/services/plpCardAction';
import { isBrowser } from 'lib/hooks/useIsomorphicLayoutEffect';
import useOwnRouter from 'lib/hooks/useOwnRouter';
import { usePlpStore } from '../../DataStore';
import UrlValidation from "../../../../../lib/utils/helpers/urlValidation";
import refactorFilter from '../../../../../lib/utils/helpers/refactorFilter';

export const useSearchListing = () => {
  const hasAuth = useHasAuth();
  const { userDevice } = useGlobalStore();
  const {
    filterData: filtersData,
    setSeoResult: setSeo,
    seoResult,
    url: currentUrl,
    page,
    sort,
    setCurrentPageCount,
    updateSaveSearch,
  } = usePlpStore();
  const [mounted, setMounted] = useState(false);
  const router = useOwnRouter();
  const isBuy = router.router.asPath.includes('buy');

  const urlFactory = new UrlValidation(currentUrl);
  // console.log("urlFactory",urlFactory);
  const url = urlFactory.fullPathname;
  const {
    data: plpListing,
    isLoading,
    isError,
    isFetching,
  } = NewPlpService.useNewPlpListQuery(
      url,
    filtersData,
    { page, sort }
  );

  const featureLeads = plpListing ? plpListing.featuredResult : [];

  useEffect(() => {
    if (isBrowser()) {
      setMounted(true);
    }
  }, []);

  useEffect(() => {
    setCurrentPageCount(
      plpListing && plpListing.result.length || 0
    );
  }, [JSON.stringify(plpListing?.result)]);
  useEffect(() => {
    if (plpListing && mounted) {
      setSeo(plpListing.seo);
      updateSaveSearch({
        title: plpListing.seo.title,
        content: {
          filters: refactorFilter(filtersData),
          page: 0,
          sort: [sort],
          size:10
        },
      });
      if(plpListing.url) {
        router.push(`/${plpListing?.url}`, undefined, {
          shallow: true,
        });
      }
    }
  }, [JSON.stringify(plpListing)]);

  // console.log("plpListing in useSearchListing",plpListing);

  // const { data: pathVariableData } = NewPlpService.usePathVariable(
  //   {
  //     ...filtersData,
  //     ...(filtersData.location && {
  //       location: (filtersData.location as any[]).map((item) =>
  //         typeof item === 'number' ? item : +item.id
  //       ),
  //     }),
  //   },
  //   true
  // );

  // const { data: favStatus } = PlpActionService.useGetFavoriteStatusQeury({
  //   glistingIdentifiers: plpListing
  //     ? plpListing.content?.map((item) => item.identifier)
  //     : [],
  // });

  // const plpListingContent = plpListing?.content.map((item, index) => {
  //   (item as PlpTypes.GListingContent & { hasFav: boolean }).hasFav = get(
  //     favStatus,
  //     `[${index}]`,
  //     false
  //   );
  //   return item as PlpTypes.GListingContent & { hasFav: boolean };
  // });


  // const setCoun = useCallback(() => {
  // setCurrentPageCount(
  //   plpListingContent?.filter(
  //     (lisitng) => lisitng.type === PlpTypes.ContentType.Regular
  //   ).length || 0
  // );
  // }, [JSON.stringify(plpListingContent)]);

  // const adsIndexes = useMemo(
  //     () => plpListing?.adPlaces?.map((adp) => adp.index),
  //     [JSON.stringify(plpListing?.adPlaces)]
  // );

  return {
    // plpListing: {
    //   ...plpListing,
    //   content: plpListing?.result,
    // },
    // adsIndexes,
    // favStatus: hasAuth ? favStatus : [],
    plpListing,
    isLoading,
    isFetching,
    isError,
    userDevice,
    seoResult,
    featureLeads,
    filtersData,
    isBuy,
  };
};
